import { render, staticRenderFns } from "./ir-readypay.vue?vue&type=template&id=0d07e28c&scoped=true"
import script from "./ir-readypay.vue?vue&type=script&lang=js"
export * from "./ir-readypay.vue?vue&type=script&lang=js"
import style0 from "./ir-readypay.vue?vue&type=style&index=0&id=0d07e28c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d07e28c",
  null
  
)

export default component.exports